export const NOVEL_REQUEST = "NOVEL_REQUEST";
export const NOVEL_SUCCESS = "NOVEL_SUCCESS";
export const NOVEL_FAILED = "NOVEL_FAILED";
